var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"preloader mar-l1"}):_vm._e(),_vm._l((_vm.nodes),function(node){return _c('ui-folder-node',_vm._b({key:node.id},'ui-folder-node',{ node, selectedId: _vm.selectedId, selectNode: _vm.selectNode, getNodes: _vm.getNodes },false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }